import { ChevronDownIcon } from '@heroicons/react/24/solid';
import PropTypes from 'prop-types';

import InfoBubble from 'features/signup/InfoBubble';
import Button from 'honeydew/Button';

function SignupFooter({
    hideInfoBubble,
    infoBubbleDescription,
    infoBubbleTitle,
    isSubmitButtonDisabled,
    onClick,
    showScrollDownButton,
    submitButtonText,
    submitButtonType,
}) {
    return (
        <div className="fixed bottom-0 left-0 z-10 flex w-full flex-col items-center">
            {(infoBubbleDescription || infoBubbleTitle) && !hideInfoBubble && (
                <InfoBubble description={infoBubbleDescription} title={infoBubbleTitle} />
            )}
            {showScrollDownButton && (
                <div className="flex w-full flex-row-reverse">
                    <button
                        type="button"
                        className="m-10 flex h-30 w-30 items-center justify-center rounded-full bg-white shadow-grey-light drop-shadow-lg"
                        onClick={() => window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })}
                    >
                        <ChevronDownIcon className="h-20 w-20" />
                    </button>
                </div>
            )}
            <div className="w-full bg-white p-25">
                <div className="mx-auto max-w-[350px]">
                    <Button onClick={onClick} type={submitButtonType} size="md" disabled={isSubmitButtonDisabled}>
                        {submitButtonText}
                    </Button>
                </div>
            </div>
        </div>
    );
}

SignupFooter.propTypes = {
    hideInfoBubble: PropTypes.bool,
    infoBubbleDescription: PropTypes.node,
    infoBubbleTitle: PropTypes.node,
    isSubmitButtonDisabled: PropTypes.bool,
    onClick: PropTypes.func,
    submitButtonText: PropTypes.string,
    submitButtonType: PropTypes.string,
};

SignupFooter.defaultProps = {
    hideInfoBubble: false,
    infoBubbleDescription: null,
    infoBubbleTitle: null,
    isSubmitButtonDisabled: true,
    onClick: null,
    submitButtonText: 'Continue',
    submitButtonType: 'submit',
};

export default SignupFooter;
